import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Menu, X } from "lucide-react";
import { WaveMark } from "./WaveMark";
import { useBooking, VILLA } from "../data";

const LINKS = [
    { label: "Overview", id: "overview" },
    { label: "Gallery", id: "gallery" },
    { label: "Amenities", id: "amenities" },
    { label: "Experiences", id: "experiences" },
    { label: "Availability", id: "availability" },
    { label: "Location", id: "location" },
    { label: "Contact", id: "contact" },
];

export function scrollToId(id) {
    const el = document.getElementById(id);
    if (!el) return;
    if (window.__lenis) window.__lenis.scrollTo(el, { offset: -70, duration: 1.4 });
    else el.scrollIntoView({ behavior: "smooth" });
}

export default function Navbar() {
    const [scrolled, setScrolled] = useState(false);
    const [open, setOpen] = useState(false);
    const { openBooking } = useBooking();

    useEffect(() => {
        const fn = () => setScrolled(window.scrollY > 60);
        window.addEventListener("scroll", fn, { passive: true });
        return () => window.removeEventListener("scroll", fn);
    }, []);

    return (
        <motion.header
            initial={{ y: -80, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.9, delay: 0.4, ease: [0.22, 1, 0.36, 1] }}
            className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${scrolled ? "bg-[#FAF8F5]/90 backdrop-blur-xl shadow-[0_8px_30px_-12px_rgba(15,40,55,0.25)]" : "bg-transparent"}`}
            data-testid="navbar"
        >
            <div className="max-w-7xl mx-auto px-5 lg:px-8 h-[70px] flex items-center justify-between">
                <button onClick={() => window.__lenis ? window.__lenis.scrollTo(0, { duration: 1.4 }) : window.scrollTo({ top: 0, behavior: "smooth" })} className="flex items-center gap-3" data-testid="navbar-logo">
                    <WaveMark size={36} light={!scrolled} />
                    <span className={`font-serif-d text-lg tracking-wide ${scrolled ? "text-[#0F2837]" : "text-white"}`}>
                        Fernandina Shores <span className="text-[#C49A45]">#6322</span>
                    </span>
                </button>
                <nav className="hidden lg:flex items-center gap-7">
                    {LINKS.map((l) => (
                        <button key={l.id} onClick={() => scrollToId(l.id)} data-testid={`nav-link-${l.id}`}
                            className={`text-[13px] tracking-[0.12em] uppercase font-medium transition-colors ${scrolled ? "text-[#5C6A78] hover:text-[#0F2837]" : "text-white/80 hover:text-white"}`}>
                            {l.label}
                        </button>
                    ))}
                </nav>
                <div className="flex items-center gap-3">
                    <button onClick={() => openBooking()} data-testid="navbar-book-now-button"
                        className="btn-amber-lux hidden sm:inline-flex items-center rounded-full px-6 py-2.5 text-sm font-semibold tracking-wide">
                        Book a Stay
                    </button>
                    <button className={`lg:hidden ${scrolled ? "text-[#0F2837]" : "text-white"}`} onClick={() => setOpen(!open)} data-testid="navbar-mobile-menu-button" aria-label="Menu">
                        {open ? <X size={24} /> : <Menu size={24} />}
                    </button>
                </div>
            </div>
            {open && (
                <div className="lg:hidden bg-[#FAF8F5] border-t border-[#E5DCCB] px-6 py-5 flex flex-col gap-4" data-testid="navbar-mobile-menu">
                    {LINKS.map((l) => (
                        <button key={l.id} onClick={() => { setOpen(false); scrollToId(l.id); }} className="text-left text-[#0F2837] font-medium" data-testid={`nav-mobile-link-${l.id}`}>
                            {l.label}
                        </button>
                    ))}
                    <button onClick={() => { setOpen(false); openBooking(); }} className="btn-amber-lux rounded-full px-6 py-3 text-sm font-semibold" data-testid="nav-mobile-book-button">
                        Book a Stay — {VILLA.unit}
                    </button>
                </div>
            )}
        </motion.header>
    );
}
